import {createStyles} from '@mantine/core';

export const MODEL_HUB_LISTING_TABLE_VERTICAL_SPACING = 14;

export const useModelHubListingTableStyles = createStyles((theme) => ({
  listingContent: {
    flex: '1 1 0',
    minHeight: 0,
  },
  table: {
    '& thead th': {
      backgroundColor: theme.colors.gray[0],
      borderBottom: `1px solid ${theme.colors.gray[3]}`,
      color: theme.colors.gray[6],
      fontSize: 13,
      fontWeight: 600,
      letterSpacing: '0.03em',
      position: 'sticky',
      textTransform: 'uppercase' as const,
      top: 0,
      zIndex: 1,
    },

    '& tbody tr:hover': {
      backgroundColor: theme.colors.gray[0],
    },

    '& tbody tr:focus-visible': {
      outline: `2px solid ${theme.fn.rgba(theme.colors.blue[6], 0.35)}`,
      outlineOffset: -2,
    },

    '& td, & th': {
      verticalAlign: 'middle',
    },
  },
  tablePaper: {
    flexShrink: 1,
    minHeight: 0,
    overflow: 'auto',
  },
}));
